// Mock data for Samaniega's Landscaping LLC

export const services = [
  {
    id: 1,
    title: "Landscaping Services",
    description:
      "Complete landscape design and installation for residential and commercial properties.",
    icon: "trees",
  },
  {
    id: 2,
    title: "Garden Maintenance",
    description:
      "Regular maintenance to keep your gardens beautiful year-round.",
    icon: "flower",
  },
  {
    id: 3,
    title: "Water Fountain Designs",
    description:
      "Custom water features that add elegance to your outdoor space.",
    icon: "waves",
  },
  {
    id: 4,
    title: "Artificial Grass Installation",
    description: "Low-maintenance, beautiful artificial turf for any space.",
    icon: "grass",
  },
  {
    id: 5,
    title: "Natural Grass Installation",
    description: "Professional sod installation and lawn establishment.",
    icon: "leaf",
  },
  {
    id: 7,
    title: "Flooring",
    description: "Outdoor flooring solutions for decks, patios, and more.",
    icon: "layers",
  },
  {
    id: 8,
    title: "Fence Installation",
    description: "Quality fencing for privacy, security, and aesthetic appeal.",
    icon: "fence",
  },
  {
    id: 9,
    title: "Pavers",
    description:
      "Beautiful paver installations for walkways, driveways, and patios.",
    icon: "grid",
  },
];

export const trustIndicators = [
  {
    id: 1,
    title: "Free Estimates",
    icon: "file-text",
  },
  {
    id: 2,
    title: "Licensed",
    icon: "award",
  },
  {
    id: 3,
    title: "Bonded",
    icon: "shield-check",
  },
  {
    id: 4,
    title: "Insured",
    icon: "shield",
  },
];

export const galleryImages = [
  {
    id: 1,
    src: "/img/wall2.png",
    alt: "Wall Installation",
  },
  {
    id: 2,
    src: "/img/grass2.png",
    alt: "Real Grass Project",
  },
  {
    id: 4,
    src: "/img/fence.jpeg",
    alt: "Fence Installation",
  },
  {
    id: 5,
    src: "/img/Fountain.jpeg",
    alt: "Fountain Design",
  },
  {
    id: 6,
    src: "/img/pavers3.png",
    alt: "Paver Walkway",
  },
  {
    id: 7,
    src: "/img/pavers4.png",
    alt: "Paver Patio",
  },
  {
    id: 8,
    src: "/img/pavers5.png",
    alt: "Paver Project",
  },
  {
    id: 9,
    src: "/img/wall1.png",
    alt: "Retaining Wall",
  },
  {
    id: 10,
    src: "/img/grass1.png",
    alt: "Artificial Grass Installation",
  },
];

// Mock form submission handler
export const submitContactForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      resolve({
        success: true,
        message: "Thank you! We'll contact you shortly.",
      });
    }, 1000);
  });
};
